/** Opciones de fetch para polls: corta peticiones colgadas (evita que el chain de setTimeout muera). */
export function pollRequestInit(timeoutMs: number): RequestInit | undefined {
  if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
    return { signal: AbortSignal.timeout(timeoutMs) };
  }
  return undefined;
}

export function isAbortError(e: unknown): boolean {
  return (
    (e instanceof DOMException && e.name === 'AbortError') ||
    (typeof e === 'object' &&
      e !== null &&
      'name' in e &&
      (e as { name: string }).name === 'TimeoutError')
  );
}
